import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgLocalFlavorSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 3.25c-1.027 0-1.99.463-2.684 1.25-.69.783-1.066 1.828-1.066 2.9v6.8c0 1.072.375 2.117 1.066 2.9.694.787 1.657 1.25 2.684 1.25h1.662l2.776 3.146a.75.75 0 0 0 1.124 0l2.777-3.146H17c1.027 0 1.99-.463 2.684-1.25.69-.783 1.066-1.828 1.066-2.9V7.4c0-1.072-.375-2.117-1.066-2.9-.694-.787-1.657-1.25-2.684-1.25H7Zm5 3.5a.25.25 0 0 1 .214.121l1.468 2.447 2.447 1.468a.25.25 0 0 1 0 .428l-2.447 1.468-1.468 2.447a.25.25 0 0 1-.428 0l-1.468-2.447-2.447-1.468a.25.25 0 0 1 0-.428l2.447-1.468 1.468-2.447A.25.25 0 0 1 12 6.75Z",
  fill: "currentColor"
})));

export { SvgLocalFlavorSolid as default };
